import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6clm7lye: FaireBrandEntity = {
  token: "b_6clm7lye",
  type: "brand",
  name: "Hi-Line Gift Ltd.",
  avatarUrl:
    "https://cdn.faire.com/fastly/cf347de1691f21bce601f6c2c2fd7c0a37743376fe46ac2f61b0f44efa8793b9.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/240a7af908ded45073ad44ea5db2402bc7c0c4943b512f4772711d9898ebd3f4.png",
  logoUrl:
    "https://cdn.faire.com/fastly/cf347de1691f21bce601f6c2c2fd7c0a37743376fe46ac2f61b0f44efa8793b9.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/240a7af908ded45073ad44ea5db2402bc7c0c4943b512f4772711d9898ebd3f4.png",
  location: "Mississauga, ON, CAN",
  minimumOrderDollars: 208,
  rating: 4.8,
  reviewCount: 78,
  isInsider: false,
  description:
    "HI-LINE GIFT LTD. is one of the leading Furniture, Garden and Home Decor distributors in North America. Since the privately-owned company opened its doors in 1991, it has quickly established itself as a key partner to many of the large home and garden re-sellers across North America. Hi-Line's quality products are stocked by retailers of all sizes, from independent gift stores to some of the biggest, respected retailers worldwide.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:17.313Z",
    importedBy: "entity-db-cli",
  },
};
